import React from "react";
import { RouteObject } from "react-router-dom";
import { LoggedInProps } from "modules/common/components/routing/AnonymousRoute";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import { SessionType } from "modules/session/auth/models/session";
import { OrderQuestionStoreType } from "./models/store";
import { OrderQuestionsPage } from "./components/QuestionsPage";

// задание адресуется путём: ссылкой на него можно поделиться
const path = `${routes.orders.orderQuestions}/:questionId?`;

export const buildRoutes = ({ store, session, loggedIn }: RoutesProps): RouteObject[] => [
  {
    path,
    element: (
      <ProtectedRoute loggedIn={loggedIn}>
        <OrderQuestionsPage store={store} session={session} />
      </ProtectedRoute>
    ),
  },
];

interface RoutesProps extends LoggedInProps {
  store: OrderQuestionStoreType;
  session: SessionType;
}
